// extracted by mini-css-extract-plugin
export default {"Folder":"_Folder--UhaSt","OriginalLocationContainer":"_OriginalLocationContainer--LUHyq"};